import React from 'react'
import PropTypes from 'prop-types'
import { FaChevronDown } from 'react-icons/fa'
import nofollow from '../../../utils/helpers/nofollow'

import { LinkWrapper, Link, Icon, ToolTip, SubList } from './styled'

export const LinkItem = ({ url, title, links = [], target }) => {
  const hasSubLinks = links.length > 0

  return (
    <LinkWrapper hasSubLinks={hasSubLinks}>
      <Link href={url} target={target} rel={nofollow(target)}>
        {title}
      </Link>
      {hasSubLinks && (
        <Icon>
          <FaChevronDown />
        </Icon>
      )}

      {hasSubLinks && (
        <ToolTip data-csshook="tooltip">
          <SubList>
            {links.map(l => (
              <Link
                key={l.title}
                href={l.url}
                target={l.target}
                rel={nofollow(l.target)}
              >
                {l.title}
              </Link>
            ))}
          </SubList>
        </ToolTip>
      )}
    </LinkWrapper>
  )
}

LinkItem.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
    })
  ),
}

export default LinkItem



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/LinkItem.js